import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class AdminContactService {

  serviceBaseURL: string = environment.serviceBaseUrl;
  constructor(private http: HttpClient) { }

  getAccountDetails(): Promise<any> {
    return this.http.get(this.serviceBaseURL + 'Kesavi/GetAccountDetails').toPromise();
  }

  addAccountDetails(account): Promise<any> {
    return this.http.post(this.serviceBaseURL + "Kesavi/AddAccountDetails", account).toPromise();
  }

  editAccountDetails(account): Promise<any> {
    return this.http.post(this.serviceBaseURL + "Kesavi/EditAccountDetails", account).toPromise();
  }

  deleteAccountDetailsByID(ID): Promise<any> {
    return this.http.get(this.serviceBaseURL + 'Kesavi/DeleteAccountDetails/' + ID).toPromise();
  }


  getOfficeDetails(): Promise<any> {
    return this.http.get(this.serviceBaseURL + 'Kesavi/GetOfficeDetails').toPromise();
  }

  addOfficeDetails(office): Promise<any> {
    return this.http.post(this.serviceBaseURL + "Kesavi/AddOfficeDetails", office).toPromise();
  }

  editOfficeDetails(office): Promise<any> {
    return this.http.post(this.serviceBaseURL + "Kesavi/EditOfficeDetails", office).toPromise();
  }

  deleteOfficeDetailsByID(ID): Promise<any> {
    return this.http.get(this.serviceBaseURL + 'Kesavi/DeleteOfficeDetails/' + ID).toPromise();
  }


  getFrachisesDetails(): Promise<any> {
    return this.http.get(this.serviceBaseURL + 'Kesavi/GetFrachisesDetails').toPromise();
  }

  addFrachisesDetails(franchises): Promise<any> {
    return this.http.post(this.serviceBaseURL + "Kesavi/AddFrachisesDetails", franchises).toPromise();
  }

  editfrachisesDetails(franchises): Promise<any> {
    return this.http.post(this.serviceBaseURL + "Kesavi/EditFrachisesDetails", franchises).toPromise();
  }

  deleteFrachisesDetailsByID(ID): Promise<any> {
    return this.http.get(this.serviceBaseURL + 'Kesavi/DeleteFrachisesDetails/' + ID).toPromise();
  }


}